<template>
    <div class="vehicle-page-flow__steps-wrap">
            <ul class="vehicle-page-flow__steps">
                <li class="vehicle-page-flow__step" 
                    v-for="(step,index) in steps" :key="step.id" :class="{ 'vehicle-page-flow__step--active': currentStep == index }">
                    <div class="vehicle-page-flow__step-badge">
                        {{ step.id }}
                    </div>
                    <p class="vehicle-page-flow__step-name">
                        {{ step.name }}
                    </p>
                </li>
            </ul>
        </div>
</template>
<script>
export default {
    name: "flowSteps",
    props: ['steps', 'currentStep']
};
</script>
